var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationGrowth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.963 14.037C54.125 14.456 50 18.336 50 21c0 1.458 1.542 3 3 3 2.664 0 6.544-4.125 6.963-9.963zM53 26c-2.57 0-5-2.43-5-5 0-4.162 5.679-9 13-9h1v1c0 7.321-4.838 13-9 13zM30.037 22.037C30.456 27.875 34.336 32 37 32c1.458 0 3-1.542 3-3 0-2.664-4.125-6.544-9.963-6.963zM37 34c-4.162 0-9-5.679-9-13v-1h1c7.321 0 13 4.838 13 9 0 2.57-2.43 5-5 5zM44 42h2V21h-2z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-2c0-3.375 2.199-5.613 2.293-5.707l6-6 1.414 1.414-6 6C47.693 27.722 46 29.474 46 32M46 40h-2c0-2.556-1.69-4.276-1.707-4.293l-6-6 1.414-1.414 6 6C43.801 34.387 46 36.625 46 40M60 52h-2c0-4.962-5.832-9-13-9-3.882 0-7.743 1.398-10.329 3.741l-1.342-1.482C36.316 42.552 40.57 41 45 41c8.271 0 15 4.935 15 11",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 58h-2c0-2.206 1.794-4 4-4h11c1.103 0 2-.897 2-2s-.897-2-2-2h-9.176l-11-4H21v-2h9.176l11 4H50c2.206 0 4 1.794 4 4s-1.794 4-4 4H39c-1.103 0-2 .897-2 2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.244 68h-2.415l-17-6H22v-2h4.171l17 6h1.585l24.63-12.808c.274-.314.614-.843.614-1.192a2.002 2.002 0 00-1.862-1.995l-15.84 4.95-.596-1.91L68 48c2.206 0 4 1.794 4 4 0 1.371-1.159 2.573-1.292 2.706l-.247.181L45.244 68M16 60h2v-2h-2zM12 60h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 64H8v-2h12V44H8v-2h12c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationGrowth;